import React, { useRef, useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';


function StatusBar({
  data, loading = false, onClick, closemodal, getLetters, setIsOverflowing = () => { }, expanded, isOverflowing = false, categoryCounts
}) {
  const containerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleClose = () => {
    setExpandedIndex(null);
  }


  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        const container = containerRef.current;
        const firstRowBottom =
          container.children[0]?.offsetTop + container.children[0]?.offsetHeight;
        let overflowing = false;
        for (let i = 1; i < container.children.length; i++) {
          if (container.children[i].offsetTop > firstRowBottom) {
            overflowing = true;
            break;
          }
        }
        setIsOverflowing(overflowing);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [data]);

  const handleExpand = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };
  const [showTableSection, setShowTableSection] = useState(false);
  const [letterTypeCounts, setLetterTypeCounts] = useState();

  const ModalClose = () => {
    setShowTableSection(false);
    closemodal();
    setExpandedIndex(null)
  }




  console.log("closemodal")
  console.log(closemodal)
  console.log("expanded")
  console.log(expandedIndex)

  const [selectedCardIndex, setSelectedCardIndex] = useState(null);


  return (
    <>
      <label style={{ marginLeft: 'auto', color: '#2576bc', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }} onClick={() => setShowTableSection(true)}>View Status</label>

      <Modal show={showTableSection} onHide={ModalClose} dialogClassName="log-timeline-modall">
        <Modal.Header closeButton>
          <Modal.Title>View Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div
            // className="modal-content"
            // onClick={(e) => e.stopPropagation()}
            >
              {/* <span
                className="modal-close"
                onClick={() => setShowModal(false)}
              >
                &times;
              </span> */}

              <div
                className={`statusbar-con ${expanded ? "expanded" : "collapsed"}`}
                ref={containerRef}
              >
                {data.map((item, index) => (
                  <div
                    key={`${item.title}-${index}`}
                    className="status-card"
                    // onClick={() => handleExpand(index)}
                    // onClick={onClick ? () => onClick(item.value) : null}
                    onClick={() => {
                      setSelectedCardIndex(index);
                      handleExpand(index);
                      if (onClick) {
                        onClick(item.value);
                      }
                    }}
                    style={{
                      backgroundColor: selectedCardIndex === index ? '#d0e6ff' : 'white', // light blue for selected
                      cursor: 'pointer'
                    }}
                  >
                    <label className="status-title">
                      {item.title.charAt(0).toUpperCase() +
                        item.title.slice(1).toLowerCase()}
                    </label>

                    {loading ? (
                      <div className="spinner-vsmall" />
                    ) : (
                      <label className="status-label">{item.label ?? 0}</label>
                    )}
                    {(expandedIndex === index && loading !== true && expanded === true) && (
                      <div className="expanded-content" style={{
                        position: 'absolute',
                        ...(expandedIndex >= 16 && expandedIndex <= 30 ? { bottom: '5%' } : {})
                      }}>
                        {/* <div className="flex-row justify-end">
                          <button
                            style={{ marginTop: "5px", marginRight: "5px", width: "1.8vw" }}
                            title="Remove Field"
                            onClick={handleClose}
                            className="file-clear clear-button2"
                          >
                            X
                          </button>
                        </div> */}
                        <div className="category-counts-box" style={{ position: "relative" }}>

                          <div className="category-grid">
                            <div className="category-item non-timebound">
                              <span>Non-Timebound:</span>
                              <span>{categoryCounts?.non_timebound}</span>
                            </div>
                            <div className="category-item newly-added">
                              <span>Newly Added:</span>
                              <span>{categoryCounts?.newly_added}</span>
                            </div>
                            <div className="category-item due-soon">
                              <span>Due in Next 3 Days:</span>
                              <span>{categoryCounts?.due_in_next_3_days}</span>
                            </div>
                            <div className="category-item overdue">
                              <span>Overdue:</span>
                              <span>{categoryCounts?.overdue}</span>
                            </div>
                          </div>
                          {/* 
                          <StatusBar isOverflowing={isOverflowing} expanded={expanded} setIsOverflowing={setIsOverflowing} onClick={handleStatusCardClick} loading={buffer}
                                data={[{ title: 'All Letters', label: resultData, value: 'null' }, { title: 'BBS', label: letterTypeCounts?.BBS?.count, value: 'BBS' }, { title: 'BILLING', label: letterTypeCounts?.BILLING?.count, value: 'billing' }, { title: 'Billing', label: letterTypeCounts?.Billing?.count, value: 'billing' }, { title: 'COS', label: letterTypeCounts?.COS?.count, value: 'cos' }, { title: 'DESIGN AND DRAWING', label: letterTypeCounts?.DESIGN_AND_DRAWING?.count, value: 'Design & Drawing' }, { title: 'DRAIN', label: letterTypeCounts?.DRAIN?.count, value: 'Drain' }, { title: 'Design', label: letterTypeCounts?.Design.count, value: 'Design' }, { title: 'EOT', label: letterTypeCounts?.EOT?.count, value: 'eot' }, { title: 'HYDROLOGY', label: letterTypeCounts?.HYDROLOGY?.count, value: 'Hydrology' }, { title: 'Informative', label: letterTypeCounts?.Informative?.count, value: 'informative' }, { title: 'Milestone', label: letterTypeCounts?.Milestone?.count, value: 'Milestone' }, { title: 'NCR', label: letterTypeCounts?.NCR?.count, value: 'ncr' }, { title: 'NOC', label: letterTypeCounts?.NOC?.count, value: 'noc' }, { title: 'Others', label: letterTypeCounts?.Others?.count, value: 'other' }, { title: 'P AND P', label: letterTypeCounts?.P_AND_P?.count, value: 'P&P' }, { title: 'QAP', label: letterTypeCounts?.QAP?.count, value: 'QAP' }, { title: 'Q AND ME', label: letterTypeCounts?.Q_AND_ME?.count, value: 'Q & ME' }, { title: 'Query', label: letterTypeCounts?.Query?.count, value: 'query' }, { title: 'ROAD SAFETY', label: letterTypeCounts?.ROAD_SAFETY?.count, value: 'Road Safety' }, { title: 'STRUCTURE', label: letterTypeCounts?.STRUCTURE?.count, value: 'Structure' }, { title: 'SURVEY', label: letterTypeCounts?.SURVEY?.count, value: 'Survey' }, { title: 'Show Cause', label: letterTypeCounts?.ShowCause?.count, value: 'show-cause' }, { title: 'Site Progress', label: letterTypeCounts?.SiteProgress?.count, value: 'SiteProgress' }, { title: 'WORK PLAN', label: letterTypeCounts?.WORK_PLAN.count, value: 'Work Plan' }]}
                                 />        */}
                        </div>
                        {/* Add more detailed content or stats here */}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

        </Modal.Body>
      </Modal>

      {/* <button
        onClick={() => setShowModal(true)}
        className="open-modal-btn"
      >
        View Status
      </button> */}

      {/* {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="modal-close"
              onClick={() => setShowModal(false)}
            >
              &times;
            </span>

            <div
              className={`statusbar-con ${expanded ? "expanded" : "collapsed"}`}
              ref={containerRef}
            >
              {data.map((item, index) => (
                <div
                  key={`${item.title}-${index}`}
                  className="status-card"
                  onClick={() => handleExpand(index)}
                >
                  <label className="status-title">
                    {item.title.charAt(0).toUpperCase() +
                      item.title.slice(1).toLowerCase()}
                  </label>

                  {loading ? (
                    <div className="spinner-vsmall" />
                  ) : (
                    <label className="status-label">{item.label ?? 0}</label>
                  )}

                  
                  {expandedIndex === index && (
                    <div className="expanded-content">
                      <p><strong>Stat ID:</strong> {item.value}</p>
                      <p><strong>Details:</strong> This card represents "{item.title}" with label "{item.label}".</p>
                     
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )} */}

      <style jsx>{`
     


        .expanded-content {
        position: absolute;
    z-index: 999999999999999999999999999;

    background:white;
box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    left:100%;
    border-radius: 8px;
    border: 1px solid #2576bc;
        }

       
      `}</style>
    </>
  );
}

export default StatusBar;
